var React = require('react');

function IconChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.5 12L9 19.5l-1.05-1.05L14.4 12 7.95 5.55 9 4.5l7.5 7.5z"}));
}

IconChevronRight.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","viewBox":"0 0 24 24"};

module.exports = IconChevronRight;

IconChevronRight.default = IconChevronRight;
